var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"chart",staticClass:"chart"}),( _vm.analysisData && _vm.analysisData.length===0)?_c('NoneData'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }